const locale = {
  GUEST_DISPLAYNAME: 'Guest',
  LOCATION: 'Institution',
  DEFAULT_LOCATION: 'Ontario, Canada',
  INFO_POPOVER_STUDENT_LOCATION: 'Institution',
  INFO_POPOVER_PROFILE: 'Purdue University',
  ADMIN_PROFILE: 'Admin',
  NO_MAJORS_LENGTH: 'No career fields info',
  NO_ACADEMIC_PROGRAMS: 'No academic programs info',
  ADD_MAJOR: 'Add your first career field',
  ADD_ACADEMIC_PROGRAM: 'Add your first academic program',
};

export default locale;
